import { render, staticRenderFns } from "./training.vue?vue&type=template&id=ffa83540&"
import script from "./training.vue?vue&type=script&lang=ts&"
export * from "./training.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "training.vue"
export default component.exports